import { OrganizationAccessLevel } from "@overmap-ai/common"

export const organizationAccessLevelData: Record<OrganizationAccessLevel, { label: string }> = {
	[OrganizationAccessLevel.GUEST]: { label: "Guest" },
	[OrganizationAccessLevel.BASIC]: { label: "Basic" },
	[OrganizationAccessLevel.ADMIN]: { label: "Admin" },
}
